/**
 * Inernal dependencies
 */
import { applyEdits } from 'state/utils';
import isEditedLayoutDirty from './is-edited-layout-dirty';
import getLayout from './get-layout';
import getEdits from './get-edits';

export default (state, id) => {
	if (isEditedLayoutDirty(state, id)) {
		let layout = getLayout(state, id);
		let edits = getEdits(state, id);
		layout = applyEdits(layout, edits);
		return layout;
	}
	return getLayout(state, id);
};
